import { HttpAuditService } from './../../service/http-audit.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractAuditDto, AuditGroupDto, AuditModificationDto, PartnerDto, ResultListDto, RolePermissionEnum } from '../../service/dto';
import { finalize, map, Observable, Subscription } from 'rxjs';
import { HttpPartnerService } from '../../service/http-partner.service';
import { AuthService } from '../../service/auth.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
	selector: 'app-partner-view',
	standalone: false,
	templateUrl: './partner-view.component.html',
	styleUrl: './partner-view.component.scss'
})
export class PartnerViewComponent implements OnInit, OnDestroy {
	subscription = new Subscription();
	id!: number;
	partner!: PartnerDto;
	loading = false;
	selectedTabIndex = 0;
	modifications!: Observable<AbstractAuditDto[]>;

	constructor(
		private service: HttpPartnerService,
		private auditService: HttpAuditService,
		private authService: AuthService,
		private activatedRoute: ActivatedRoute,
		private sanitizer: DomSanitizer) { }

	ngOnInit(): void {
		this.loading = false;
		this.subscription.add(
			this.service.get(+this.activatedRoute.snapshot.paramMap.get('partnerId')!)
				.pipe(finalize(() => this.loading = true))
				.subscribe((result) => {
					this.partner = result;
					this.modifications = this.auditService.getModificationsToPartner(this.partner.id,0,1000).pipe(
						map(item => item.records as AbstractAuditDto[])
					);
				})
		);
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	get getLogoUrl(): SafeUrl {
		return this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + this.partner.image!.imageData);
	}
}
